<p-dialog [header]="header" [(visible)]="visible" (onHide)="closeDialog()" [style]="{width: width}">
  <div class="text-center">{{message}}</div>
  <div class="flex justify-content-end mt-4">
   <remitter-button
      (click)="triggerAction()" 
      label='Yes'
      icon='check'                                          
   />   
  </div>
 </p-dialog>